import { defaultAxios, IParams } from './base';

export interface IFetchBaseCustomer extends IParams {
  osType?: string;
  mgntCd?: string;
  ctn?: string;
  srcCd?: string;
  queueSeq?: string;
  passMoney?: string;
  mediaCd?: string;
  challengeSeq?: string;
}

export const fetchBaseCustomer = (params: IFetchBaseCustomer) => {
  return defaultAxios().post(`/base/customer`, params); // defaultAxios 제거, 쿼리즈에서 처리
};
